/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Portuguese (Brazil)
export default {
  'fabric.reactions.add': 'Adicionar reação',
  'fabric.reactions.error.unexpected': 'As reações estão indisponíveis no momento',
  'fabric.reactions.loading': 'Carregando...',
  'fabric.reactions.more.emojis': 'Mais emojis',
  'fabric.reactions.other.reacted.users': '{count, plural, one {e mais um} other {e mais {count}}}',
  'fabric.reactions.reactwithemoji': 'Reaja com um emoji {emoji}',
  'fabric.reactions.summary': 'Veja todas as reações de usuários',
  'reaction-picker-trigger.add.reaction.message': 'Adicionar reação',
  'reactions.dialog.close': 'Fechar',
  'reactions.dialog.emoji.name': '{emojiName}',
  'reactions.dialog.left.navigate': 'Navegar para a esquerda',
  'reactions.dialog.reactions.count':
    '{count, plural, one {{count,number} reação total} other {{count,number} reações totais}}',
  'reactions.dialog.right.navigate': 'Navegar para a direita',
  'reactions.dialog.viewall': 'Ver tudo',
  'reactions.dialog.viewall.tooltip': 'Veja todas as reações de usuários',
};
